import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgTransactionTypeCashVoucherIcon = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 18,
	height: 19,
	viewBox: "0 0 18 19",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [/* @__PURE__ */ _jsx("g", {
		clipPath: "url(#clip0_534_11826)",
		children: /* @__PURE__ */ _jsxs("g", {
			clipPath: "url(#clip1_534_11826)",
			children: [
				/* @__PURE__ */ _jsx("path", {
					fillRule: "evenodd",
					clipRule: "evenodd",
					d: "M3.375 4.90894C3.375 3.8881 4.20255 3.06055 5.22339 3.06055H12.7766C13.7974 3.06055 14.625 3.8881 14.625 4.90894V15.0294C14.625 16.1558 13.2386 16.6918 12.4809 15.8583L12.2812 15.6387L11.4133 16.3373C10.9622 16.7005 10.3191 16.7005 9.86793 16.3373L9 15.6387L8.13207 16.3373C7.68094 16.7005 7.03781 16.7005 6.58668 16.3373L5.71875 15.6387L5.51906 15.8583C4.76141 16.6918 3.375 16.1558 3.375 15.0294V4.90894ZM4.3125 3.99805V15.6387L5.71875 14.2324L7.35938 15.6387L9 14.2324L10.6406 15.6387L12.2938 14.2324L13.6875 15.6387V3.99805H4.3125Z",
					fill: "black"
				}),
				/* @__PURE__ */ _jsx("path", {
					fillRule: "evenodd",
					clipRule: "evenodd",
					d: "M6.1875 11.6543H11.8125V12.5918H6.1875V11.6543Z",
					fill: "black"
				}),
				/* @__PURE__ */ _jsx("path", {
					fillRule: "evenodd",
					clipRule: "evenodd",
					d: "M6.1875 8.8418H11.8125V9.7793H6.1875V8.8418Z",
					fill: "black"
				}),
				/* @__PURE__ */ _jsx("path", {
					fillRule: "evenodd",
					clipRule: "evenodd",
					d: "M6.1875 6.0293H9V6.9668H6.1875V6.0293Z",
					fill: "black"
				})
			]
		})
	}), /* @__PURE__ */ _jsxs("defs", { children: [/* @__PURE__ */ _jsx("clipPath", {
		id: "clip0_534_11826",
		children: /* @__PURE__ */ _jsx("rect", {
			width: 15,
			height: 15,
			fill: "white",
			transform: "translate(1.5 2.2793)"
		})
	}), /* @__PURE__ */ _jsx("clipPath", {
		id: "clip1_534_11826",
		children: /* @__PURE__ */ _jsx("rect", {
			width: 15,
			height: 15,
			fill: "white",
			transform: "translate(1.5 2.2793)"
		})
	})] })]
});
export default SvgTransactionTypeCashVoucherIcon;
